var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ 'h-full': _vm.$route.name === '404' },attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('div',{domProps:{"innerHTML":_vm._s(_vm.scripts)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }